import React from "react";
import InfoTooltip from "../../../../components/common/InfoTooltip";
import RadioGroup, { Option } from "../../../../components/form/RadioGroup";
import {
  DestinationStatusEnum,
  DestinationTypeEnum,
} from "../../../../enums/destination";

interface StatusConfig {
  id: DestinationStatusEnum;
  name: string;
  description: string;
}

const STATUS_CONFIGS: Record<DestinationTypeEnum, StatusConfig[]> = {
  [DestinationTypeEnum.WORDPRESS]: [
    {
      id: DestinationStatusEnum.DRAFT,
      name: "draft",
      description:
        "Save the post as a draft — only visible to users with admin access to the blog.",
    },
    {
      id: DestinationStatusEnum.PENDING,
      name: "pending",
      description: "Mark the post as pending editorial approval.",
    },
    {
      id: DestinationStatusEnum.PUBLISH,
      name: "publish",
      description:
        "Publish the post — visible to anyone with access to the blog.",
    },
    {
      id: DestinationStatusEnum.FUTURE,
      name: "future",
      description: "Automatically publish at a future date.",
    },
  ],
  [DestinationTypeEnum.SHOPIFY]: [
    {
      id: DestinationStatusEnum.HIDDEN,
      name: "hidden",
      description:
        "Save the post as a draft — only visible to users with admin access to the blog.",
    },
    {
      id: DestinationStatusEnum.VISIBLE,
      name: "visible",
      description:
        "Publish the post — visible to anyone with access to the blog.",
    },
  ],
  // Google Docs has no publish status
  [DestinationTypeEnum.GOOGLE_DOCS]: [],
};

interface StatusSelectorProps {
  status: string;
  onChange: (status: string) => void;
  platform: DestinationTypeEnum;
}

export const StatusSelector = ({
  status,
  onChange,
  platform,
}: StatusSelectorProps) => {
  const statusOptions = STATUS_CONFIGS[platform];

  return (
    <div>
      <div className="mb-2 tracking-wide font-medium leading-6 text-gray-900 text-xs flex items-center gap-2 uppercase">
        <div className="flex">
          Status
          <span className="text-red-500 align-super ml-0.5">*</span>
        </div>
        <InfoTooltip id="subject">
          <div className="flex flex-col gap-2">
            {statusOptions.map((option) => (
              <div key={option.id}>
                <b>{option.name}:</b> {option.description}
              </div>
            ))}
          </div>
        </InfoTooltip>
      </div>
      <RadioGroup
        options={statusOptions.map(({ id, name }) => ({ id, name }))}
        name="status"
        selected={status}
        onClick={({ id }: Option) => onChange(id)}
      />
    </div>
  );
};
